export default __webpack_public_path__ + "static/media/General's Vambraces of Dynastic Rule.190cd6fa.jpg";